import { Feature } from "ol"
import { Geometry } from "ol/geom"
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import { createContext } from "react"

export const VectorLayerContext = createContext<{ olLayer: VectorLayer<VectorSource<Feature<Geometry>>> } | null>(null)
